import React, { useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import UsersTable from "./UsersTable";
import TeamsTable from "./TeamsTable";

const UserManagementContent = () => {
    const user = JSON.parse(localStorage.getItem("authUser"));
    const [activeTab, setActiveTab] = useState("users");

    return (
        <div>
            <Nav tabs className="d-flex justify-content-center">
                <NavItem className="accordion-gradient-border">
                    <NavLink
                        className={classnames({ active: activeTab === "users" })}
                        onClick={() => setActiveTab("users")}
                        style={{
                            cursor: "pointer",
                            color: activeTab === "users" ? "#000" : "#000" // Black if active, White if not
                        }}
                    >
                        Users
                    </NavLink>
                </NavItem>

                <NavItem className="accordion-gradient-border">
                    <NavLink
                        className={classnames({ active: activeTab === "teams" })}
                        onClick={() => setActiveTab("teams")}
                        style={{
                            cursor: "pointer",
                            color: activeTab === "users" ? "#fff" : "#000" // Black if active, White if not
                        }}
                    >
                        Teams
                    </NavLink>
                </NavItem>
            </Nav>

            <TabContent activeTab={activeTab} className="pt-3">
                <TabPane tabId="users">
                    <UsersTable token={user.token} />
                </TabPane>

                <TabPane tabId="teams">
                    <TeamsTable token={user.token} />
                </TabPane>
            </TabContent>
        </div>
    );
};

export default UserManagementContent;